import React from "react";

import {
  QuestionLayout,
  type QuestionLayoutProps,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";

import { useBasicInfo } from "../BasicInfoContext";
import type { BasicInfoFlowRoute } from "../types";

const CONTEXT_CHIP_KEYS: Partial<Record<BasicInfoFlowRoute, string>> = {
  SexAtBirth: "about_you",
  BasicInfo: "about_you",
  QuickExposure: "about_you",
  Pregnancy: "pregnancy",
  Endometriosis: "medical_history",
  PCOS: "medical_history",
  Varicocele: "medical_history",
  Cancer: "medical_history",
  Allergies: "allergies",
  AllergiesDetails: "allergies",
  Medications: "medications",
};

type BasicInfoQuestionLayoutProps = Omit<
  QuestionLayoutProps,
  "helpAccessibilityLabel" | "progressPercent" | "sectionLabel"
> & {
  route: BasicInfoFlowRoute;
};

export function BasicInfoQuestionLayout({
  route,
  ...props
}: BasicInfoQuestionLayoutProps) {
  const t = useTranslations();
  const { progressPercent } = useBasicInfo(route);
  const contextChipKey = CONTEXT_CHIP_KEYS[route] ?? "about_you";

  return (
    <QuestionLayout
      {...props}
      helpAccessibilityLabel={t(
        "med_history.basic_info.flow.help_accessibility_label",
      )}
      progressPercent={progressPercent}
      sectionLabel={t(`med_history.basic_info.flow.chips.${contextChipKey}`)}
    />
  );
}
